import type { RedirectPropsApi } from '../../cms/core-components/redirect/models'
import { PageBase } from './pageBase'

export class PageResponse extends PageBase {
    public components: { [componentName: string]: unknown }
    public ancestorComponents: { [pageName: string]: { [componentName: string]: unknown } }
    public redirectDetailsElement: RedirectPropsApi
}
